import { Link } from "react-router-dom";
import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { WHATSAPP } from "@/lib/api";
import { Logo } from "@/components/Navbar";

const COLS = [
  ["Book", [["/flights", "Flights"], ["/hotels", "Hotels"], ["/cabs", "Taxi & cabs"], ["/packages", "Holiday packages"]]],
  ["Plan", [["/packages?region=domestic", "India trips"], ["/packages?region=international", "International trips"], ["/planner", "AI itinerary planner"]]],
  ["Company", [["/contact", "Contact us"], ["/terms", "Terms & conditions"], ["/privacy", "Privacy policy"], ["/refund", "Cancellation & refund"]]],
];

export const Footer = () => (
  <footer className="relative mt-24 bg-[#0D1B2A] text-slate-300 grain" data-testid="site-footer">
    <div className="relative mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-8 md:grid-cols-5">
      <div className="md:col-span-2 space-y-5">
        <Logo light />
        <p className="max-w-sm text-sm leading-relaxed text-slate-400">
          Flights, hotels, taxis and handcrafted holidays across India and the world — priced in rupees, planned with care.
        </p>
        <div className="space-y-2 text-sm">
          <p className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#E07A5F]" />nextvisionsolutions@rediffmail.com</p>
          <a href={WHATSAPP.link} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4 text-[#25D366]" />WhatsApp / Call: {WHATSAPP.display}</a>
          <p className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#E07A5F]" />Mon–Sat, 9am–8pm IST</p>
          <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#E07A5F]" />India</p>
        </div>
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <p className="eyebrow !text-[#F4A261] mb-4">{title}</p>
          <ul className="space-y-2.5 text-sm">
            {links.map(([to, label]) => (
              <li key={to}><Link to={to} className="transition-colors hover:text-white" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="relative border-t border-white/10 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} NextVisionSolutions. All prices in Indian Rupees (₹), inclusive of applicable taxes.
    </div>
  </footer>
);
